import styled, { css } from 'styled-components';

type StatusProps = {
  active?: boolean;
  selected?: boolean;
  isSuccessful?: boolean;
  isError?: boolean;
};

export const Container = styled.div<StatusProps>`
  width: 153px;
  display: flex;
  align-items: center;
  gap: 16px;
  border: 1px solid #cbcbcb;
  border-radius: 8px;
  padding: 8px 12px;

  ${({ selected }) =>
    selected &&
    css`
      border: 1px solid #0b29fb;
      background: #f0f2ff;
    `}

  ${({ active, selected }) =>
    !active &&
    !selected &&
    css`
      border: 1px solid #cbcbcb;
      background: #ffffff;
    `}

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const Img = styled.img`
  width: 14px;
  height: 14px;
`;

export const Text = styled.span<StatusProps>`
  font-family: 'Mangueira', sans-serif;
  font-weight: 400;
  font-size: 10px;
  line-height: 15px;
  color: #000;

  ${({ active, selected }) =>
    !active &&
    !selected &&
    css`
      color: #b1b1b1;
    `}
`;

export const ImageWrapper = styled.div<StatusProps>`
  width: 24px;
  height: 24px;
  background: #0b29fb;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;

  ${({ active, selected }) =>
    !active &&
    !selected &&
    css`
      background: #b1b1b1;
    `}

  ${({ isSuccessful }) =>
    isSuccessful &&
    css`
      background: #1ba23f;
    `}

  ${({ isError }) =>
    isError &&
    css`
      background: #fc0d1b;
    `}
`;
